/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /vise/packages/app-share/src/services/fetch-zz-config/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { ZzConfig, FetchZzConfigReq } from '@/types/services/fetch-zz-config';

/**
 *
 * 获取分享页的配置信息
 * @export
 * @param
 * @return {*}  {(Promise<ZzConfig | null>)}
 */
export default async function fetchZzconfig(params: FetchZzConfigReq): Promise<ZzConfig| null> {
  const { key, flag } = params;
  const fetchConfig: AjaxConfig = {
    url: `https://qzonestyle.gtimg.cn/qzone/qzactStatics/configSystem/data/${key}/config${flag}.js`,
    method: 'jsonp',
    timeout: 2000,
    jsonpCallback: `callback_${key}_config${flag}`,
  };
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return null;
  try {
    const { request } = wslAjax;
    const res = await request<ZzConfig>(fetchConfig);
    return res;
  } catch (err) {
    console.error('接口fetchZzconfig出现了一些问题');
  }
  return null;
}
